import { debounce } from 'lodash';
import { useState, useEffect } from 'react';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const SIZE_XS: Breakpoint = 'xs';
export const SIZE_SM: Breakpoint = 'sm';
export const SIZE_MD: Breakpoint = 'md';
export const SIZE_LG: Breakpoint = 'lg';
export const SIZE_XL: Breakpoint = 'xl';
export const SIZE_XXL: Breakpoint = 'xxl';

const resolveBreakpoint = (width: number): Breakpoint[] => {
  if (width < 576) {
    return [SIZE_XS];
  }

  if (width >= 1200) {
    return [SIZE_XS, SIZE_SM, SIZE_MD, SIZE_LG, SIZE_XL];
  }

  if (width >= 992) {
    return [SIZE_XS, SIZE_SM, SIZE_MD, SIZE_LG];
  }

  if (width >= 768) {
    return [SIZE_XS, SIZE_SM, SIZE_MD];
  }

  if (width >= 576) {
    return [SIZE_XS, SIZE_SM];
  }

  return [SIZE_XS, SIZE_SM, SIZE_MD, SIZE_LG, SIZE_XL, SIZE_XXL];
};

/** Get Media Query Breakpoints in React */
export const useBreakpoint = (): Breakpoint => {
  const [size, setSize] = useState(() => resolveBreakpoint(window.innerWidth));

  useEffect(() => {
    const calcInnerWidth = debounce(function () {
      setSize(resolveBreakpoint(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return size;
};
